var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "NewHome"
    },
    [
      _c("div", { staticClass: "training_platform_header" }, [
        _vm.screenWidth > 601
          ? _c("div", { staticClass: "logo_wrap" }, [
              _c("img", {
                staticClass: "logo",
                attrs: { src: "/static/images/homepage/zljy-logo.png", alt: "" }
              }),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.deptName))])
            ])
          : _c("div"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "login-user" },
          [
            _c(
              "div",
              { staticClass: "btn" },
              [
                _vm.isPlatformadmin
                  ? _c(
                      "el-button",
                      {
                        on: {
                          click: function($event) {
                            return _vm.handleCommand("a")
                          }
                        }
                      },
                      [_vm._v("教务中心")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        return _vm.handleCommand("b")
                      }
                    }
                  },
                  [_vm._v("个人中心")]
                ),
                _vm._v(" "),
                false
                  ? _c("div", { staticClass: "news" }, [
                      _c("div", { staticClass: "num" }, [
                        true
                          ? _c(
                              "span",
                              { staticStyle: { transform: "scale(.9)" } },
                              [_vm._v("99")]
                            )
                          : _c(
                              "span",
                              {
                                staticStyle: {
                                  transform: "translateY(-4px)",
                                  "font-weight": "bold"
                                }
                              },
                              [_vm._v("…")]
                            )
                      ]),
                      _vm._v(" "),
                      _c("i", { staticClass: "el-icon-message" })
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-dropdown",
              {
                attrs: { "show-timeout": 0 },
                on: { command: _vm.handleCommand }
              },
              [
                _c("div", { staticClass: "user-name el-dropdown-link" }, [
                  _c("div", { staticClass: "imgBox" }, [
                    _c("img", { attrs: { src: _vm.imgUrl } })
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "login-name" }, [
                    _vm._v(_vm._s(_vm.loginName))
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  [
                    _c("el-dropdown-item", { attrs: { command: "d" } }, [
                      _vm._v("退出")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "training_platform_content" }, [
        _c("div", { staticClass: "top" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _c("h3", [_vm._v("快速入口")]),
              _vm._v(" "),
              _vm.quickEntrance.length > 0
                ? _c(
                    "draggable",
                    {
                      attrs: { tag: "ul" },
                      on: { update: _vm.productSort },
                      model: {
                        value: _vm.quickEntrance,
                        callback: function($$v) {
                          _vm.quickEntrance = $$v
                        },
                        expression: "quickEntrance"
                      }
                    },
                    _vm._l(_vm.quickEntrance, function(item, key) {
                      return _c(
                        "li",
                        {
                          key: key,
                          attrs: { "data-key": item.id },
                          on: {
                            click: function($event) {
                              return _vm.enterProduct(item)
                            }
                          }
                        },
                        [
                          _c("p", { staticClass: "product_classify" }, [
                            _vm._v(_vm._s(item.applicationType))
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "product_cover" }, [
                            _c("img", {
                              attrs: {
                                src: item.picurl
                                  ? item.picurl
                                  : "/static/images/homepage/productCover/bg1.png",
                                alt: ""
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "product_name" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.name) +
                                  "\n                "
                              ),
                              item.status == 0
                                ? [_c("span", [_vm._v("已过期")])]
                                : _vm._e(),
                              _vm._v(" "),
                              item.status == 2
                                ? [_c("span", [_vm._v("未开通")])]
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "product_delete el-icon-close",
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                return _vm.deleteProduct(item)
                              }
                            }
                          })
                        ]
                      )
                    }),
                    0
                  )
                : _c("div", { staticClass: "no_list" }, [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/image/sources/table_no_data.png"),
                        alt: ""
                      }
                    }),
                    _vm._v(" "),
                    _c("p", [_vm._v("将应用设为常用即可加入快速入口")])
                  ])
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bot" }, [
          _c(
            "div",
            { staticClass: "content" },
            [
              _vm._m(0),
              _vm._v(" "),
              false
                ? _c("div", { staticClass: "major_search" }, [
                    _c("p", [_vm._v("专业群")]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(_vm.specialtyList, function(item, i) {
                        return _c(
                          "li",
                          {
                            key: i,
                            class: { active: _vm.majorCurId === i },
                            on: {
                              click: function($event) {
                                return _vm.switchMajor(i, item.id)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(item.specialtyName) + "\n              "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "classify_search" }, [
                _c("p", [_vm._v("专业分类")]),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(_vm.classifyList, function(item, i) {
                    return item.status == 1
                      ? _c(
                          "li",
                          {
                            key: i,
                            class: { active: _vm.classifyCurId === i },
                            on: {
                              click: function($event) {
                                return _vm.switchClassify(i)
                              }
                            }
                          },
                          [_vm._v(_vm._s(item.name) + "\n              ")]
                        )
                      : _vm._e()
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              false
                ? _c("div", { staticClass: "classify_search" }, [
                    _c("p", [_vm._v("应用类型")]),
                    _vm._v(" "),
                    _c(
                      "ul",
                      _vm._l(_vm.applicationTypeIdList, function(item, i) {
                        return _c(
                          "li",
                          {
                            key: i,
                            class: { active: _vm.applicationCurId === i },
                            on: {
                              click: function($event) {
                                return _vm.switchApplication(i)
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(item.applicationType) + "\n              "
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              false
                ? _c(
                    "div",
                    { staticClass: "status_search" },
                    [
                      _c("p", [_vm._v("开通状态")]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticStyle: {
                            width: "120px",
                            "margin-right": "auto"
                          },
                          attrs: { placeholder: "请选择" },
                          on: { change: _vm.switchStatus },
                          model: {
                            value: _vm.statusCurId,
                            callback: function($$v) {
                              _vm.statusCurId = $$v
                            },
                            expression: "statusCurId"
                          }
                        },
                        _vm._l(_vm.statusList, function(item, i) {
                          return _c("el-option", {
                            key: i,
                            attrs: { value: i, label: item.name }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "200px" },
                          attrs: { placeholder: "请输入搜索内容" },
                          nativeOn: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.searchProduct.apply(null, arguments)
                            }
                          },
                          model: {
                            value: _vm.searchProdName,
                            callback: function($$v) {
                              _vm.searchProdName = $$v
                            },
                            expression: "searchProdName"
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "align-items": "center"
                              },
                              attrs: { slot: "suffix" },
                              slot: "suffix"
                            },
                            [
                              _vm.searchProdName
                                ? _c("i", {
                                    staticClass: "el-icon-error el-input__icon",
                                    staticStyle: {
                                      cursor: "pointer",
                                      "font-size": "16px"
                                    },
                                    on: { click: _vm.handleIconClick }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("i", {
                                staticClass: "el-icon-search el-input__icon",
                                staticStyle: {
                                  cursor: "pointer",
                                  "font-size": "22px"
                                },
                                on: { click: _vm.searchProduct }
                              })
                            ]
                          )
                        ]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "ul",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.prodLoading,
                      expression: "prodLoading"
                    }
                  ],
                  staticClass: "product_list"
                },
                _vm._l(_vm.productList, function(item, i) {
                  return _c("li", { key: i }, [
                    _c(
                      "div",
                      {
                        staticClass: "cover_box",
                        on: {
                          click: function($event) {
                            return _vm.enterProduct(item)
                          }
                        }
                      },
                      [
                        _c("p", { staticClass: "product_classify" }, [
                          _vm._v(_vm._s(item.applicationType))
                        ]),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: item.picurl
                              ? item.picurl
                              : "/static/images/homepage/productCover/bg1.png",
                            alt: ""
                          }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "product_info" }, [
                      _c("div", { staticClass: "product_info_top" }, [
                        _c(
                          "h4",
                          [
                            _c("p", { attrs: { title: item.name } }, [
                              _vm._v(_vm._s(item.name) + " ")
                            ]),
                            _vm._v(" "),
                            item.status == 0
                              ? [_c("span", [_vm._v("已过期")])]
                              : _vm._e(),
                            _vm._v(" "),
                            item.status == 2
                              ? [_c("span", [_vm._v("未开通")])]
                              : _vm._e()
                          ],
                          2
                        ),
                        _vm._v(" "),
                        item.status == 1
                          ? _c(
                              "div",
                              { staticClass: "el_switch_wrap" },
                              [
                                _c("span", { staticClass: "label" }, [
                                  _vm._v("设为常用")
                                ]),
                                _vm._v(" "),
                                _c("el-switch", {
                                  on: {
                                    change: function($event) {
                                      return _vm.isCommonlyUsed(
                                        item.isFrequentlyUsed,
                                        item.id
                                      )
                                    }
                                  },
                                  model: {
                                    value: item.isFrequentlyUsed,
                                    callback: function($$v) {
                                      _vm.$set(item, "isFrequentlyUsed", $$v)
                                    },
                                    expression: "item.isFrequentlyUsed"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "product_info_bot" }, [
                        _c("p", { attrs: { title: item.briefIntroduction } }, [
                          _vm._v(_vm._s(item.briefIntroduction))
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "product_enter",
                          on: {
                            click: function($event) {
                              return _vm.enterProduct(item)
                            }
                          }
                        },
                        [_c("i", { staticClass: "el-icon-arrow-right" })]
                      )
                    ])
                  ])
                }),
                0
              ),
              _vm._v(" "),
              _c("el-pagination", {
                staticClass: "new_home_pagination",
                attrs: {
                  "current-page": _vm.pageTotal.currentPage,
                  background: "",
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.pageTotal.pageSize,
                  "pager-count": 5,
                  layout: "total, sizes, prev, pager, next",
                  total: _vm.pageTotal.total
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function($event) {
                    return _vm.$set(_vm.pageTotal, "currentPage", $event)
                  },
                  "update:current-page": function($event) {
                    return _vm.$set(_vm.pageTotal, "currentPage", $event)
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "apply_dialog",
          attrs: {
            modal: true,
            title: "申请试用",
            "modal-append-to-body": true,
            visible: _vm.applyFor,
            "show-close": true,
            "close-on-click-modal": true,
            "close-on-press-escape": true
          },
          on: {
            "update:visible": function($event) {
              _vm.applyFor = $event
            }
          }
        },
        [
          _c(
            "div",
            { staticClass: "apply_dialog_wrap" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  staticClass: "demo-ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    "status-icon": "",
                    rules: _vm.rules,
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "姓名:", prop: "name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          placeholder: "请输入姓名"
                        },
                        model: {
                          value: _vm.ruleForm.name,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "name", $$v)
                          },
                          expression: "ruleForm.name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系电话:", prop: "mobile" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "tel",
                          autocomplete: "off",
                          placeholder: "请输入联系电话"
                        },
                        model: {
                          value: _vm.ruleForm.mobile,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "mobile", $$v)
                          },
                          expression: "ruleForm.mobile"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "单位名称:", prop: "unit_name" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          placeholder: "请输入单位名称"
                        },
                        model: {
                          value: _vm.ruleForm.unit_name,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "unit_name", $$v)
                          },
                          expression: "ruleForm.unit_name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "您的职业:", prop: "post" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          placeholder: "请输入您的职业"
                        },
                        model: {
                          value: _vm.ruleForm.post,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "post", $$v)
                          },
                          expression: "ruleForm.post"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "邮箱:", prop: "email" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "text",
                          autocomplete: "off",
                          placeholder: "请输入邮箱"
                        },
                        model: {
                          value: _vm.ruleForm.email,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "email", $$v)
                          },
                          expression: "ruleForm.email"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注:", prop: "remark" } },
                    [
                      _c("el-input", {
                        attrs: { type: "textarea" },
                        model: {
                          value: _vm.ruleForm.remark,
                          callback: function($$v) {
                            _vm.$set(_vm.ruleForm, "remark", $$v)
                          },
                          expression: "ruleForm.remark"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "padding-bottom": "20px"
                      }
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.submitForm("ruleForm")
                            }
                          }
                        },
                        [_vm._v("提交")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "all_box" }, [
      _c("h3", [_vm._v("全部应用")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-88259c56", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-88259c56","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/NewHome.vue
// module id = null
// module chunks = 